<template>
  <SnowDataPoint
    :label="label"
    :left-align="leftAlign"
    :row="row"
    :value-class-names="valueClassNames"
  >
    <font-awesome-icon
      v-if="!isAllAccess"
      icon="lock"
    />
    <span
      v-else
      :class="colorForBaseVsAverage"
    >
      {{ baseVsAveragePercent }}
    </span>
  </SnowDataPoint>
</template>

<script>
import { mapState } from 'pinia';
import { formatPercent } from '@@/utils/CommonUtils';
import { useUserStore } from '@@/stores/User';

export default {
  name: 'SnowBaseVsAverageDataPoint',

  props: {
    baseVsAverage: {
      type: Number,
      default: null,
    },
    label: {
      type: String,
      default: 'Base vs. Avg',
    },
    leftAlign: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(useUserStore, ['isAllAccess']),

    baseVsAveragePercent() {
      return formatPercent(this.baseVsAverage);
    },

    /**
     * @see https://github.com/cloudninewx/OpenSnow-Android-Neue/blob/develop/model/src/main/java/com/cloudnineweather/android/model/domain/snowdepth/SnowDepthModel.kt#L100
     */
    colorForBaseVsAverage() {
      if (typeof this.baseVsAverage !== 'number') {
        return 'text-light-color';
      }

      if (this.baseVsAverage >= 0 && this.baseVsAverage <= 0.80) {
        return 'text-saturated-red-color';
      }

      if (this.baseVsAverage >= 0.80 && this.baseVsAverage <= 1.20) {
        return 'text-darkest-color';
      }

      return 'text-saturated-blue-color';
    },

    valueClassNames() {
      if (!this.isAllAccess) {
        return 'all-access-color';
      }

      return null;
    },
  },
};
</script>
